import { WaitingIcon } from '@/components/icons/waiting-icon'
import React from 'react'

export const ScoreCardsUpdate = ({
  message = 'Updating Metadata and Data Quality Scores',
}: {
  message?: string
}) => {
  return (
    <div className='flex items-center gap-2'>
      <div className='flex w-[575px] items-center gap-2 border border-neutral-75 p-2'>
        <WaitingIcon className='size-6 shrink-0 rounded-full bg-warning-50 text-warning-300' />
        <div className='flex w-full items-center justify-between text-sm text-neutral-700'>
          <span className='min-w-0 flex-1 truncate'>{message}</span>
        </div>
      </div>
    </div>
  )
}
